export const styles: { [key: string]: React.CSSProperties } = {
  waveCountdown: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    width: "250px",
    height: "60px",
    position: "absolute",
    top: 0,
    background: "rgba(0, 0, 0, 0.3)",
    color: "white",
    fontSize: "26px",
    fontWeight: "bold",
  },
};
